import { useConfirm } from 'material-ui-confirm'
import ProfileContext from '@/components/Context/ProfileContext'
import { useContext, useState } from 'react'
import { gaRemoveToCart } from '../googleAnalytics/actions'
import { toast } from 'react-toastify'
import logger from '../logger'
import { fetchRest } from '@/lib/hook/tanstackQuery'
import { ApiMutationEndpoint } from '@/src/ApiMutationEndpoint'

type Return = {
  loadingDelete: boolean
  // item_id des lignes en cours de suppression : permet d'afficher un loader
  // sur la ligne concernee (ou toutes les lignes du vendeur en "supprimer tout")
  deletingItemIds: string[]
  removeProductBasket: (group_products: any) => void
}

const useBasketHelper = (): Return => {
  const [deletingItemIds, setDeletingItemIds] = useState<string[]>([])
  const { basketAllRefetcher } = useContext(ProfileContext)
  const confirm = useConfirm()

  // Suppression en UN appel batch (action delete_items) : une seule requete et
  // un seul recalcul du panier cote CS-Cart, au lieu d'un DELETE par ligne
  // (chaque DELETE recalculait tout le panier, ~8s par ligne sur un gros panier)
  const removeProductBasket = async group_products => {
    confirm({ description: 'Êtes vous sûr de supprimer ces produits !' }).then(() => {
      const item_ids = group_products.map(product => String(product.item_id))
      setDeletingItemIds(item_ids)
      fetchRest({
        endpoint: ApiMutationEndpoint.BASKET.REMOVE_PRODUCTS_BATCH.endpoint,
        method: ApiMutationEndpoint.BASKET.REMOVE_PRODUCTS_BATCH.method,
        body: { action: 'delete_items', item_ids },
      })
        .then(() => {
          group_products.forEach(row => gaRemoveToCart(row))
          toast.success(t({ id: 'web_produit_supprime_du_panier' }))
          // Le loader reste affiche jusqu'au rechargement effectif du panier
          return basketAllRefetcher()
        })
        .catch(logger.error)
        .finally(() => setDeletingItemIds([]))
    })
  }

  return { loadingDelete: deletingItemIds.length > 0, deletingItemIds, removeProductBasket }
}

export default useBasketHelper
